// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hGwzf{display:flex;padding:0;margin:0;color:#767676;font-size:13px;line-height:20px;list-style:none}.hGwzf,.QuzSG{flex-wrap:wrap;align-items:center}.QuzSG{display:inline-flex}.QuzSG>a{color:#0082ff;cursor:pointer;text-decoration:none;transition:color .2s}.QuzSG>a:active{-webkit-tap-highlight-color:rgba(0,0,0,0);color:#006ee1}@media(any-hover:hover){.QuzSG>a:hover{color:#006ee1}}.QuzSG>span{display:inline-block}.QuzSG:not(:last-child):after{margin:0 8px;content:\"·\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entries": "hGwzf",
	"entry": "QuzSG"
};
module.exports = ___CSS_LOADER_EXPORT___;
